module.exports = __webpack_public_path__ + "img/jarvis-logo@2x.b39cb974.png";